import * as React from "react";

const Footer = _props => {
  return (
    <div className="ms-Grid" dir="ltr">
      <div
        className="ms-Grid-row"
        style={{
          backgroundColor: "#ffffff",
          height: 25,
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%"
        }}
      >
        <div
          className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
          style={{ textAlign: "center" }}
        >
          <span
            style={{
              color: "black",
              textAlign: "center",
              marginTop: 10,
              fontFamily: "Lato",
              fontSize: 12,
              fontWeight: "normal",
              lineHeight: "25px"
            }}
          >
            {`© 2019 SimpleLegal, Inc.`}
          </span>
        </div>
      </div>
    </div>
  );
};
export default Footer;
